export default function bookmarkCount() {
    const bookmarkBadge = document.querySelector('#wishlistIndex');
    const bookmarks = localStorage.getItem('bookmarks');
    
    let arrayBookmarks = JSON.parse(bookmarks);

    if(Array.isArray(arrayBookmarks)) {
        arrayBookmarks = arrayBookmarks.filter((bookmark) => {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const bookmarkDate = new Date(bookmark.timestamp);
            return bookmarkDate >= today;
        });
    
        localStorage.setItem('bookmarks', JSON.stringify(arrayBookmarks));
    
        if(arrayBookmarks.length > 0){
            bookmarkBadge.innerHTML = arrayBookmarks.length;
        } else {
            bookmarkBadge.innerHTML = "";
        }
    }
}
